import * as _4 from 'lodash4';
import { ConditionalStrategy, StrategySafe } from 'utility-ts-strategy';

type UserRole = 'advisor' | 'student';

export const RoleTypeStrategy = new ConditionalStrategy<ng.ui.IStateService, UserRole>({
  advisor: (state: ng.ui.IStateService) => state.includes('ap-advisor'),
  student: (state: ng.ui.IStateService) => !state.includes('ap-advisor')
});

interface IUserModeUrl {
  AP_PLAN_API_URL: string;
}

export const APUserModeAPIStrategy = new StrategySafe<IUserModeUrl, UserRole>({
  advisor: {
    AP_PLAN_API_URL: 'reg/advisorplan'
  },
  student: {
    AP_PLAN_API_URL: 'reg/academicplan'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/strategies/user_mode_api_strategy.ts